import { render, staticRenderFns } from "./ProductBatchNameTable.vue?vue&type=template&id=d8234714&"
import script from "./ProductBatchNameTable.vue?vue&type=script&lang=js&"
export * from "./ProductBatchNameTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports